import { useQuery } from '@tanstack/react-query';
import request from '@/services/api';

export const useProjectList = (params?: any) => {
  return useQuery({
    queryKey: ['project-list', params],
    queryFn: async () => {
      const res = await request.get('/course-project', { params });
      return res.data;
    }
  });
};

export const useCourseProjectList = useProjectList;
